<script>

export default {
  name: 'TermsOfServiceForConsumers'
}
</script>

<template lang="pug" src="./TermsOfServiceForConsumers.pug"></template>
